import { getSmpAsDatafanToken } from "./smp_token";
export const getSmpAsDatafanHeaders = () => {
    const smpToken = getSmpAsDatafanToken();
    return [["authorization", `Bearer ${smpToken}`]];
};
//# sourceMappingURL=smp_headers.js.map